import axios from 'axios'

export async function ChangePassword (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users`,
    JSON.stringify(json),
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function setLanguage (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users/language`,
    JSON.stringify(json),
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function GetMe () {
  return axios.get(`${window.apiConfig.APIURL}api/users/me`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}
export async function UpdateMe (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users/me`,
    JSON.stringify(json),
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}
export async function GetCompanyInformation () {
  return axios.get(`${window.apiConfig.APIURL}api/users/companyinformation`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}
export async function Register (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}
